export function isNumeric(value: unknown): value is string {
  if (typeof value !== 'string' || value.trim() === '') {
    return false
  }
  return Number.isFinite(Number(value))
}

// TODO: jeff's idea to bring to sanity our typings for ids
// we are inconsistent everywhere about what type an id has
// need to standardize on one type, maybe this can be a way to transition
export function id(value: unknown) {
  if (isNumeric(value)) {
    return Number(value)
  }
  return value
}
